<template>
<div>
  <a class="mt-2" href="#" @click="viewAllRoutes('routes')">
    <span>All Routes</span>
  </a>
</div>
</template>


<script>
export default {
  name: 'all-routes-href-links',
  props: ['iconColor', 'isFuture'],
  data () {
    return {
    }
  },
  methods: {
    viewAllRoutes (type = 'routes') {
      // console.log(this.$route.path, this.$route.path.substr(0,3) === '/es', location.pathname, location.pathname.substr(0,3) === '/es');
      // console.log('this.$route.es', this.$route.name);
      // return
      // this.$router.push({
      //   path: '/es/rutas',
      //   query: { tab: type }
      // })
      location.href = (this.$route.path.substr(0,3) === '/es') ? '/es/rutas' : '/routes'
    }
  },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
a {
	cursor: pointer;
}

[class^="icon-icon-"] {
  min-width:22px;
  display: inline-block;
}
[class^="icon-icon-light-rail"] {
  font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/AllRoutesHrefLinks.vue